<div *ngIf="showList" class="h-full">
    <div class="h-full">
        <h2 class="text-center md:text-left">Payment Methods</h2>
        <div class="tile payment-method-card" *ngFor="let pm of paymentMethod" 
            [attr.data-selected]="selectedPaymentMethod === pm.key">
                <ng-container [ngComponentOutlet]="pm.component"></ng-container>
        </div>
    </div>
</div>
<div class="h-full p-4 bg-gray-50" *ngIf="!showList">
    <mat-icon class="float-right cursor-pointer" (click)="toggleListView()" *ngIf="paymentMethod.length>1">close</mat-icon>
    <ng-container [ngComponentOutlet]="promotionalContainer"></ng-container>
</div>
